import Footer from '../commons/footer/Footer.vue'
import Header from '../commons/header/Header.vue'

export default {
  name: 'TermsAndConditions',
  components: {
    Footer,
    Header
  }
}
